module.exports = __webpack_public_path__ + "static/dina_video-12b43e9be537f53a9ff8be22e4cbc282.jpg";